enum SpotlightStatus {
    ENABLED = 'enabled',
    PARTIAL = 'partial',
    DISABLED = 'disabled',
}

export default SpotlightStatus